<template>
  <v-form v-model="$storeUm6p.ValidCandidat" lazy-validation ref="refCandidat">
    <v-expansion-panels multiple v-model="Panel.Model">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <h3>{{ $storeUm6p.Label.Title.Candidat }}</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="panel-content">
          <!-- Nom,Prénom,Genre -->
          <v-row>
            <v-col cols="4">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.Nom"
                v-model="$storeUm6p.Formulaire.Nom"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="$storeReglesBourse.obligatoire"
                class="asterisk"
                ref="Nom"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.Prenom"
                v-model="$storeUm6p.Formulaire.Prenom"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="$storeReglesBourse.obligatoire"
                class="asterisk"
                ref="Prenom"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.Genre"
                v-model="$storeUm6p.Formulaire.Genre"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="Genre"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.Genre"
                :clearable="!$storeUm6p.Formulaire.ReadOnly"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <!-- Naissance, Situation familiale -->
          <v-row>
            <v-col cols="4">
              <v-menu
                v-model="menu.dateNaissance"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                :clearable="!$storeUm6p.Formulaire.ReadOnly"
                offset-y
                min-width="auto"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    :clearable="!$storeUm6p.Formulaire.ReadOnly"
                    v-model="DateNaissanceFormated"
                    :label="$storeUm6p.Label.Candidat.DateNaissance"
                    prepend-icon="mdi-calendar"
                    ref="DateNaissance"
                    readonly
                    v-bind="attrs"
                    :disabled="$storeUm6p.Formulaire.ReadOnly"
                    :rules="$storeReglesBourse.obligatoire"
                    v-on="on"
                    @click:clear="$storeUm6p.Formulaire.DateNaissance = null"
                  />
                </template>
                <v-date-picker
                  v-model="$storeUm6p.Formulaire.DateNaissance"
                  :max="MaxDateNaissance"
                  :itemprop="$storeUm6p.Label.Candidat.DateNaissance"
                  :clearable="!$storeUm6p.Formulaire.ReadOnly"
                  :disabled="$storeUm6p.Formulaire.ReadOnly"
                  @input="menu.dateNaissance = false"
                  class="asterisk"
                />
              </v-menu>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.LieuNaissance"
                v-model="$storeUm6p.Formulaire.LieuNaissance"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="LieuNaissance"
                class="asterisk"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.SituationFamiliale"
                v-model="$storeUm6p.Formulaire.SituationFamiliale"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="SituationFamiliale"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.SituationFamiliale"
                :clearable="!$storeUm6p.Formulaire.ReadOnly"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <!-- Nationalité, mail -->
          <v-row>
            <v-col cols="4">
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.Nationalite"
                v-model="$storeUm6p.Formulaire.Nationalite"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="Nationalite"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.Pays"
                :clearable="!$storeUm6p.Formulaire.ReadOnly"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.AutreNationalite"
                v-model="$storeUm6p.Formulaire.AutreNationalite"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                ref="AutreNationalite"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.Pays"
                :clearable="!$storeUm6p.Formulaire.ReadOnly"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.Mail"
                v-model="$storeUm6p.Formulaire.Mail"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="$storeReglesBourse.emailObligatoire"
                ref="Mail"
                class="asterisk"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- cni, passeport, portable -->
          <v-row>
            <v-col cols="4">
              <v-text-field
                :label="
                  $storeUm6p.Formulaire.Nationalite ===
                  $storeCommun.DataId.Maroc
                    ? $storeUm6p.Label.Parents.Cni
                    : $storeUm6p.Label.Parents.AutreCni
                "
                v-model="$storeUm6p.Formulaire.Cni"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="Cni"
                class="asterisk"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <!-- <v-text-field 
                            :label="$storeUm6p.Label.Candidat.NoPasseport"
                            v-model="$storeUm6p.Formulaire.NoPasseport"
                            ></v-text-field> -->
            </v-col>
            <v-col cols="4">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.Portable"
                v-model="$storeUm6p.Formulaire.Portable"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="$storeReglesBourse.telephoneObligatoire"
                ref="Portable"
                class="asterisk"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- handicap, telfix -->
          <v-row>
            <v-col cols="4">
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.SituationHandicap"
                v-model="$storeUm6p.Formulaire.SituationHandicap"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="SituationHandicap"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.OuiNon"
                :clearable="!$storeUm6p.Formulaire.ReadOnly"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.TypeHandicap"
                v-model="$storeUm6p.Formulaire.TypeHandicap"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="
                  $storeUm6p.Formulaire.SituationHandicap ==
                  $storeCatalogue.DataId.Oui
                    ? $storeReglesBourse.multiObligatoire
                    : []
                "
                ref="TypeHandicap"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.NatureHandicap"
                :clearable="!$storeUm6p.Formulaire.ReadOnly"
                multiple
                v-show="
                  $storeUm6p.Formulaire.SituationHandicap ==
                  $storeCatalogue.DataId.Oui
                "
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.Fixe"
                v-model="$storeUm6p.Formulaire.Fixe"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="$storeReglesBourse.telephone"
                ref="Fixe"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-autocomplete
                label="Comment avez-vous connu la FIRSI ?"
                v-model="$storeCommun.InfosCandidature.ConnaissanceFirsi"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :readonly="$storeUm6p.Formulaire.ReadOnly"
                :rules="$storeReglesBourse.obligatoire"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.ConnaissanceFirsi"
                ref="connufirsi"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-show="
                  $storeCommun.InfosCandidature.ConnaissanceFirsi ==
                  $storeCatalogue.DataId.ConnaissanceFirsiAutre
                "
                label="Préciser"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :readonly="$storeUm6p.Formulaire.ReadOnly"
                v-model="$storeCommun.InfosCandidature.PreciserConnaissance"
                ref="preciserConnaissanceFir"
                :rules="
                  $storeCommun.InfosCandidature.ConnaissanceFirsi ==
                  $storeCatalogue.DataId.ConnaissanceFirsiAutre
                    ? $storeReglesBourse.obligatoire
                    : []
                "
                class="asterisk"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <h3>{{ $storeUm6p.Label.Title.Adresses }}</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="panel-content">
          <h4>{{ $storeUm6p.Label.Candidat.AdresseMa }}</h4>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="9">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.AdresseMaroc"
                v-model="$storeUm6p.Formulaire.AdresseMaroc"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="AdresseMaroc"
                class="asterisk"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.PaysMaroc"
                v-model="$storeUm6p.Formulaire.PaysMaroc"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="PaysMaroc"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.Pays"
                :clearable="!$storeUm6p.Formulaire.ReadOnly"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.CpMaroc"
                v-model="$storeUm6p.Formulaire.CpMaroc"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="$storeReglesBourse.obligatoireLengthDix"
                ref="CpMaroc"
                class="asterisk"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.VilleMaroc"
                v-model="$storeUm6p.Formulaire.VilleMaroc"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="VilleMaroc"
                class="asterisk"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-autocomplete
                v-if="
                  $storeUm6p.Formulaire.PaysMaroc == $storeCommun.DataId.Maroc
                "
                :label="$storeUm6p.Label.Candidat.ProvinceMaroc"
                v-model="$storeUm6p.Formulaire.ProvinceMaroc"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="ProvinceMaroc"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.Province"
                :clearable="!$storeUm6p.Formulaire.ReadOnly"
                @change="ProvinceChange"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                v-if="
                  $storeUm6p.Formulaire.PaysMaroc == $storeCommun.DataId.Maroc
                "
                :label="$storeUm6p.Label.Candidat.RegionMaroc"
                v-model="$storeUm6p.Formulaire.RegionMaroc"
                disabled
                ref="RegionMaroc"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.Region"
                :clearable="!$storeUm6p.Formulaire.ReadOnly"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <h4>{{ $storeUm6p.Label.Candidat.AdresseAu }}</h4>
          <v-divider></v-divider>
          <v-row>
            <v-col cols="9">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.AdresseAutre"
                v-model="$storeUm6p.Formulaire.AdresseAutre"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                ref="AdresseAutre"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.PaysAutre"
                v-model="$storeUm6p.Formulaire.PaysAutre"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                ref="PaysAutre"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.Pays"
                :clearable="!$storeUm6p.Formulaire.ReadOnly"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <!-- etranger : province/pays/CP -->
          <v-row>
            <v-col cols="6">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.CpAutre"
                v-model="$storeUm6p.Formulaire.CpAutre"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="$storeReglesBourse.LengthDix"
                ref="CpAutre"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :label="$storeUm6p.Label.Candidat.VilleAutre"
                v-model="$storeUm6p.Formulaire.VilleAutre"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                ref="VilleAutre"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.DepartementFrance"
                v-model="$storeUm6p.Formulaire.DepartementFrance"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                ref="DepartementFrance"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.DepartementFrance"
                :clearable="!$storeUm6p.Formulaire.ReadOnly"
                v-show="
                  $storeUm6p.Formulaire.PaysAutre ==
                  $storeCatalogue.DataId.France
                "
                @change="DepartementChange"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.RegionFrance"
                v-model="$storeUm6p.Formulaire.RegionFrance"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                ref="RegionFrance"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.RegionFrance"
                :clearable="!$storeUm6p.Formulaire.ReadOnly"
                v-show="
                  $storeUm6p.Formulaire.PaysAutre ==
                  $storeCatalogue.DataId.France
                "
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <h3>{{ $storeUm6p.Label.Title.EtatFamilial }}</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="panel-content">
          <!-- Etat familiale -->
          <v-row>
            <v-col cols="4">
              <!-- Etes-vous? -->
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.EtesVous"
                v-model="$storeCommun.InfosCandidature.EtesVous"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="$storeReglesBourse.obligatoire"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.EtesVous"
                :clearable="!$storeUm6p.Formulaire.ReadOnly"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <!-- Si à la charge d'un de mes parents -->
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.GardeConfiee"
                v-model="$storeCommun.InfosCandidature.ChargeUnParent"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="
                  $storeCommun.InfosCandidature.EtesVous ==
                    $storeCatalogue.DataId.ChargeUnParentDivorce ||
                  $storeCommun.InfosCandidature.EtesVous ==
                    $storeCatalogue.DataId.ChargeUnParentVeuf
                    ? $storeReglesBourse.obligatoire
                    : []
                "
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.ChargeParent"
                :clearable="!$storeUm6p.Formulaire.ReadOnly"
                v-show="
                  $storeCommun.InfosCandidature.EtesVous ==
                    $storeCatalogue.DataId.ChargeUnParentDivorce ||
                  $storeCommun.InfosCandidature.EtesVous ==
                    $storeCatalogue.DataId.ChargeUnParentVeuf
                "
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <!-- situation parents ? -->
              <v-autocomplete
                :label="
                  $storeCommun.InfosCandidature.EtesVous ==
                  $storeCatalogue.DataId.ChargeUnParentDivorce
                    ? $storeUm6p.Label.Candidat.ParentTuteurDivorce
                    : $storeUm6p.Label.Candidat.ParentTuteurVeuf
                "
                v-model="$storeCommun.InfosCandidature.ParentTuteurDivorce"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="
                  $storeCommun.InfosCandidature.EtesVous ==
                    $storeCatalogue.DataId.ChargeUnParentDivorce ||
                  $storeCommun.InfosCandidature.EtesVous ==
                    $storeCatalogue.DataId.ChargeUnParentVeuf
                    ? $storeReglesBourse.obligatoire
                    : []
                "
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="filteredSituationParent"
                :clearable="!$storeUm6p.Formulaire.ReadOnly"
                v-show="
                  $storeCommun.InfosCandidature.EtesVous ==
                    $storeCatalogue.DataId.ChargeUnParentDivorce ||
                  $storeCommun.InfosCandidature.EtesVous ==
                    $storeCatalogue.DataId.ChargeUnParentVeuf
                "
                class="asterisk"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <h3>{{ $storeUm6p.Label.Title.SituationFinanciere }}</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="panel-content">
          <!-- Situation financiète et pro -->
          <v-row>
            <v-col cols="6">
              <!-- Vous êtes ? -->
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.VousEtes"
                v-model="$storeCommun.InfosCandidature.VousEtes"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.VousEtes"
                :clearable="!$storeUm6p.Formulaire.ReadOnly"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <!-- Revenu net Mensuel si autre qu' etudiant -->
              <v-text-field
                :label="$storeUm6p.Label.Candidat.RevenuNetMensuel"
                v-model="$storeCommun.InfosCandidature.RevenuNetMensuel"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="
                  $storeCommun.InfosCandidature.VousEtes &&
                  $storeCommun.InfosCandidature.VousEtes !=
                    $storeCatalogue.DataId.VousEtesEtudiant
                    ? $storeReglesBourse.obligatoire
                    : []
                "
                v-show="
                  $storeCommun.InfosCandidature.VousEtes &&
                  $storeCommun.InfosCandidature.VousEtes !=
                    $storeCatalogue.DataId.VousEtesEtudiant
                "
                class="asterisk"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <!-- Disposez-vous d’un régime de protection sociale ? -->
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.ProtectionSociale"
                v-model="$storeCommun.InfosCandidature.RegimeProtectionSociale"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="ProtectionSociale"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.OuiNon"
                :clearable="!$storeUm6p.Formulaire.ReadOnly"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <!-- Si oui, veuillez préciser auprès de quel organisme -->
              <v-text-field
                :label="$storeUm6p.Label.Candidat.OrganismeProtectionSociale"
                v-model="$storeCommun.InfosCandidature.NomOrganisme"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="
                  $storeCommun.InfosCandidature.RegimeProtectionSociale ==
                  $storeCatalogue.DataId.Oui
                    ? $storeReglesBourse.obligatoire
                    : []
                "
                v-show="
                  $storeCommun.InfosCandidature.RegimeProtectionSociale ==
                  $storeCatalogue.DataId.Oui
                "
                class="asterisk"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <!-- Nombre de compte bancaire -->
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.NombreCompteBancaire"
                v-model="$storeCommun.InfosCandidature.NbCompteBancaire"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="NombreCompteBancaire"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.NbCompteBancaire"
                :clearable="!$storeUm6p.Formulaire.ReadOnly"
                class="asterisk"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6"> </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <!-- Bourse Mastercard Fondation -->
              <v-autocomplete
                :label="$storeUm6p.Label.Candidat.BourseSupplementaire"
                v-model="$storeUm6p.Formulaire.BourseSupplementaire"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                :rules="$storeReglesBourse.obligatoire"
                ref="BourseSupplementaire"
                :item-text="$storeCommun.ItemLang"
                item-value="id"
                :items="$storeCatalogue.OuiNon"
                :clearable="!$storeUm6p.Formulaire.ReadOnly"
                class="asterisk"
                @change="$storeCommun.QuestionTableau(
                  $storeUm6p.Formulaire.BourseSupplementaire,
                  $storeCommun.ListeAutresBourses,
                  {}
                )"
              />
            </v-col>
            <v-col cols="4"> </v-col>
          </v-row>
          <AutresBourses
          v-show="$storeUm6p.Formulaire.BourseSupplementaire == $storeCatalogue.DataId.Oui"/>
          <v-row>
            <v-col cols="8">
              <!-- Bénéficiez-vous d'un autre avantage financier pour vos études ? -->
              <v-checkbox
                :label="$storeUm6p.Label.Candidat.Beneficiaire"
                v-model="$storeUm6p.Formulaire.Beneficiaire"
                :disabled="$storeUm6p.Formulaire.ReadOnly"
                ref="Beneficiaire"
              />
            </v-col>
            <v-col cols="4"> </v-col>
          </v-row>
          <AutresRevenusCandidat ref="refAutresRevenusCandidat" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-form>
</template>
<script>
import moment from "moment";
import AutresBourses from "@/components/Commun/AutresBourses";
import AutresRevenusCandidat from "@/components/Commun/AutresRevenusCandidat";
export default {
  name: "candidatbourseum6p",
  components: {
    AutresBourses,
    AutresRevenusCandidat,
  },
  data() {
    return {
      // Store
      $storeUm6p: this.$storeUm6p,
      $storeCatalogue: this.$storeCatalogue,
      menu: {
        dateNaissance: false,
      },
      Panel: {
        Model: [0, 1, 2, 3],
      },
    };
  },
  computed: {
    DateNaissanceFormated() {
      return this.formatDate(this.$storeUm6p.Formulaire.DateNaissance);
    },
    MaxDateNaissance() {
      return moment(String(new Date()))
        .subtract(15, "year")
        .format("YYYY-MM-DD");
    },
    filteredSituationParent() {
      switch (this.$storeCommun.InfosCandidature.ChargeUnParent) {
        case 4891:
        case 4893:
          return this.$storeCatalogue.SituationParent.filter(
            (item) => item.id === 4897 || item.id === 4896
          );
        default:
          return this.$storeCatalogue.SituationParent.filter(
            (item) => item.id === 4895 || item.id === 4894
          );
      }
    },
  },
  methods: {
    // méthodes on change
    ProvinceChange() {
      this.$storeUm6p.Formulaire.RegionMaroc = this.$storeCatalogue.GetParentId(
        this.$storeCatalogue.Province,
        this.$storeUm6p.Formulaire.ProvinceMaroc
      );
    },

    DepartementChange() {
      this.$storeUm6p.Formulaire.RegionFrance =
        this.$storeCatalogue.GetParentId(
          this.$storeCatalogue.DepartementFrance,
          this.$storeUm6p.Formulaire.DepartementFrance
        );
    },
    ValiderForm() {
      this.$refs.refCandidat.validate();
      let listeErreur = [];
      Object.keys(this.$refs).forEach((key) => {
        if (key != "refCandidat" && key != "refAutresRevenusCandidat") {
          if (
            (!this.$refs[key].valid && this.$refs[key].valid != undefined) ||
            (this.$refs[key].valid == undefined &&
              this.$refs[key].$children != undefined &&
              this.$refs[key].$children[0] != undefined &&
              !this.$refs[key].$children[0].valid)
          ) {
            let label = this.$refs[key].label;
            if (!label) {
              let inp = this.$refs[key];
              if (!inp.$attrs) {
                inp = inp[0];
              }
              label = inp.$attrs["itemprop"];
            }
            listeErreur.push(label);
          }
        }
      });

      let liste = this.$refs.refAutresRevenusCandidat.ValiderForm();
      if (liste) {
        liste.forEach((element) => {
          listeErreur.push(element);
        });
      }

      return listeErreur;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
  },
  created() {
    document.title = "CANDIDAT | UM6P";
  },
  mounted() {
    this.$refs.refCandidat.resetValidation();
  },
};
</script>
